export const createHDFCErgoMedisureTopupFamilyReqBody = (data) => {
  let updatedReqBody = {};
  let proposerDetail;
  let insuredsArray = [];
  Object.entries(data).forEach((entry, index) => {
    switch (entry[0]) {
      case "primaryDetail":
        entry[1].forEach((item, ind) => {
          insuredsArray.push(item);
        });
        break;
      case "dependentDetail":
        proposerDetail = { ...entry[1] };
        break;
      //   case "nomineeDetail":
      //     nomineeArray = entry[1];
      //     break;
      default:
        break;
    }
  });

  let customer_details = Object.keys(proposerDetail)
    .filter(
      (key) =>
        ![
          "SameAsAbove",
          "PolicyStartDate",
          "POLICY_TERM",
          "ProposalDate",
        ].includes(key)
    )
    .reduce((res, key) => ((res[key] = proposerDetail[key]), res), {});

  updatedReqBody = {
    TransactionID: "",
    Customer_Details: { ...customer_details },
    Policy_Details: {
      PolicyStartDate: proposerDetail["PolicyStartDate"],
      ProposalDate: proposerDetail["ProposalDate"],
      BusinessType_Mandatary: "New Business",
    },
    Payment_Details: {
      GC_PaymentID: "",
      BANK_NAME: "BIZDIRECT",
      BANK_BRANCH_NAME: "BHANDUP",
      PAYMENT_MODE_CD: "EP",
      PAYER_TYPE: "CUSTOMER",
      PAYMENT_AMOUNT: "3206",
      INSTRUMENT_NUMBER: "106428032312568",
      PAYMENT_DATE: "21/03/2023",
    },
    Req_HSTPF: {
      POSP_CODE: proposerDetail['POSP_CODE'],
      PropRisks_FamilyPolicy_Mandatary: "", 
      POLICY_TERM: data?.dependentDetail?.POLICY_TERM,
      Insured_Details: insuredsArray,
    },
  };

  return updatedReqBody;
};

export const createHDFCErgoMedisureTopupIndividualReqBody = (data) => {
  let updatedReqBody = {};
  let proposerDetail;
  let insuredsArray = [];
  Object.entries(data).forEach((entry, index) => {
    switch (entry[0]) {
      case "primaryDetail":
        entry[1].forEach((item, ind) => {
          insuredsArray.push(item);
        });
        break;
      case "dependentDetail":
        proposerDetail = { ...entry[1] };
        break;
      //   case "nomineeDetail":
      //     nomineeArray = entry[1];
      //     break;
      default:
        break;
    }
  });

  let customer_details = Object.keys(proposerDetail)
    .filter(
      (key) =>
        ![
          "SameAsAbove",
          "PolicyStartDate",
          "POLICY_TERM",
          "ProposalDate",
        ].includes(key)
    )
    .reduce((res, key) => ((res[key] = proposerDetail[key]), res), {});

  updatedReqBody = {
    TransactionID: "",
    Customer_Details: { ...customer_details },
    Policy_Details: {
      PolicyStartDate: proposerDetail["PolicyStartDate"],
      ProposalDate: proposerDetail["ProposalDate"],
      BusinessType_Mandatary: "New Business",
    },
    Payment_Details: {
      GC_PaymentID: "",
      BANK_NAME: "BIZDIRECT",
      BANK_BRANCH_NAME: "BHANDUP",
      PAYMENT_MODE_CD: "EP",
      PAYER_TYPE: "CUSTOMER",
      PAYMENT_AMOUNT: "3206",
      INSTRUMENT_NUMBER: "106428032312568",
      PAYMENT_DATE: "21/03/2023",
    },
    Req_HSTPI: {
      POSP_CODE: proposerDetail['POSP_CODE'],
      POLICY_TERM: data?.dependentDetail?.POLICY_TERM,
      Insured_Details: insuredsArray,
    },
  };

  return updatedReqBody;
};
